const Footer = () => (
  <div className="bg-primary pa1 body-text">
    <div className="flex flex-column items-center w-fc m-auto pa2">
      <div className="flex flex-row flex-wrap items-center justify-center">
        <div className="no-underline underline-hover near-white fw3 pa2">
          FANVISION
        </div>
      </div>
      <div className="flex flex-row flex-wrap items-center justify-center">
        <div className="near-white fw3 pa2 tc">
          Jan. 2021. Built by Henry Wang and Adam Janicki
        </div>
      </div>
    </div>
  </div>
);

export default Footer;
